












































import { ApiClient } from "@/api/client";
import { Component, Vue } from "vue-property-decorator";
import { ToastProgrammatic as Toast } from "buefy";
import { UserAccount } from "@/interfaces/user";
import { authClient } from "@/auth0";
import { mapState } from "vuex";

@Component({
  computed: {
    ...mapState(["user"])
  }
})
export default class Settings extends Vue {
  // Mapped from vuex
  user!: UserAccount;

  // Other variables
  api: ApiClient = new ApiClient();
  data: any = {
    name: ""
  };

  mounted() {
    this.data.name = this.user.name;
  }

  async changeName() {
    const newAccount = await this.api.setUserName(this.data.name);
    this.$store.commit("setUser", newAccount);
    Toast.open({
      type: "is-success",
      message: "Dein Name wurde geändert.",
      duration: 3000,
      queue: false
    });
  }

  async changePassword() {
    const response = await authClient.changePassword(this.user.email);
    if (response) {
      Toast.open({
        type: "is-success",
        message:
          "Wir haben dir einen Link an deine Email Addeesse geschickt, mit dem du dein Passwort ändern kannst.",
        duration: 3000,
        queue: false
      });
    } else {
      Toast.open({
        type: "is-danger",
        message:
          "Dein Passwort kann gerade nicht geändert werden. Sollte das Problem bestehen, melde dich bitte bei unserem Kundenservice.",
        duration: 3000,
        queue: false
      });
    }
  }

  deleteAccount() {
    this.$buefy.dialog.confirm({
      cancelText: "Abbrechen",
      confirmText: "Konto löschen",
      type: "is-danger",
      message:
        "Möchtest du wirklich dein Account löschen? Du verlierst dadurch den Zugang zu deinen Einkäufen. " +
        "Eine Erstattung deiner Coins ist ebenfalls nicht möglich. Dieser Vorgang kann nicht rückgängig gemacht werden.",
      onConfirm: () => {
        Toast.open({
          type: "is-success",
          message: "Dein Account wurde gelöscht.",
          duration: 3000,
          queue: false
        });
        this.$router.push("/logout");
      }
    });
  }
}
